import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          // meta: {
          //   title: '首页'
          // }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          // meta: {
          //   title: '软件产品'
          // },
          children: [
            //硬件
            {
              path: '/hardware',
              redirect: '/hardware/LTE'
            },
            {
              path: '/hardware/LTE',
              name: 'hardware',
              component: resolve => require(['@/view/HardwareLTE'], resolve),
            },
            {
              path: '/hardware/handleDevice',
              name: 'hardware',
              component: resolve => require(['@/view/HardwareHandleDevice'], resolve),
            },
            {
              path: '/hardware/nighthawk',
              name: 'hardware',
              component: resolve => require(['@/view/HardwareNighthawk'], resolve),
            },
            {
              path: '/hardware/ownNetwork',
              name: 'hardware',
              component: resolve => require(['@/view/HardwareOwnNetwork'], resolve),
            },
            {
              path: '/hardware/smartCamera',
              name: 'hardware',
              component: resolve => require(['@/view/HardwareSmartCamera'], resolve),
            },
            {
              path: '/hardware/singleSoldier',
              name: 'hardware',
              component: resolve => require(['@/view/HardwareWirelessSingleSoldier'], resolve),
            }
          ]
        }, {
          path: '/solution',
          name: 'solution',
          component: resolve => require(['@/view/Solution'], resolve),
          // children:[{
          //   path: '/solution',
          //   redirect: '/solution/smartDetection'
          // },{
          //   path: '/solution/smartDetection',
          //   name: 'solution',
          //   component: resolve => require(['@/view/SolutionSmartDetection'], resolve),
          // },
          //   //软件
          //   {
          //     path: '/solution/police',
          //     name: 'solution',
          //     component: resolve => require(['@/view/SoftwarePolice'], resolve),
          //   },
          //   {
          //     path: '/solution/monitor',
          //     name: 'solution',
          //     component: resolve => require(['@/view/SoftwareMonitor'], resolve),
          //   },
          //   {
          //     path: '/solution/community',
          //     name: 'solution',
          //     component: resolve => require(['@/view/SoftwareCommunity'], resolve),
          //   },
          //
          // ]

          children: [{
            path: '/solution',
            redirect: '/solution/smartMonitor'
          },
            //电子哨兵智能监测预警系统
            {
              path: '/solution/smartMonitor',
              name: 'solution',
              component: resolve => require(['@/view/solution/smartMonitor'], resolve),
            },
            //重点阵地周界入侵监测预警系统
            {
              path: '/solution/invasion',
              name: 'solution',
              component: resolve => require(['@/view/solution/invasion'], resolve),
            },
            //无网无电地区物联网应用解决方案
            {
              path: '/solution/IOT',
              name: 'solution',
              component: resolve => require(['@/view/solution/IOT'], resolve),
            },
            //智慧农业数字化实时监测方案
            {
              path: '/solution/farming',
              name: 'solution',
              component: resolve => require(['@/view/solution/farming'], resolve),
            },

          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          // meta: {
          //   title: '相关服务'
          // }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          // meta: {
          //   title: '新闻动态'
          // }
        }, {
          path: '/newsdetail/:id',
          name: 'newsdetail',
          component: resolve => require(['@/view/NewsDetail'], resolve),
        }, {
          path: '/companyinfo',
          name: 'companyinfo',
          component: resolve => require(['@/view/companyinfo'], resolve),
          children: [
            //公司简介
            {
              path: '/companyinfo',
              redirect: '/companyinfo/CompanyIntroduction'
            },
            //公司简介
            {
              path: '/companyinfo/CompanyIntroduction',
              name: 'CompanyIntroduction',
              component: resolve => require(['@/view//companyinfo/CompanyIntroduction'], resolve),
            },
            //知识产权
            {
              path: '/companyinfo/IPR',
              name: 'IPR',
              component: resolve => require(['@/view//companyinfo/IPR'], resolve),
            },
            //公司动态
            {
              path: '/companyinfo/history',
              name: 'history',
              component: resolve => require(['@/view//companyinfo/history'], resolve),
            },
            //公司动态
            {
              path: '/companyinfo/news',
              name: 'news',
              component: resolve => require(['@/view//companyinfo/news'], resolve),
            },
          ]
          // meta: {
          //   title: '公司介绍'
          // }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          // meta: {
          //   title: '工作机会'
          // }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          // meta: {
          //   title: '联系我们'
          // }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'], resolve),
          // meta: {
          //   title: '相关服务'
          // }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js